import { useCallback, useContext, useEffect, useState } from "react";
import { ForceGraph3D } from "react-force-graph";
import { GET } from "../../api/requests";
import { AuthContext } from "../../contexts/AuthContext";
import { useQuery } from "react-query";

export default function ForceGraph() {
  const { token } = useContext(AuthContext);
  const [gd, setGraphData] = useState(false);

  const { data, isError, isLoading, error } = useQuery(
    ["team"],
    () => {
      return GET(`/node-tree`);
    },
    {
      enabled: !!token,
      cacheTime: Infinity,
      staleTime: Infinity,
    }
  );
  const createNodesAndLinks = useCallback(() => {
    if (data) {
      let nodes = [];
      let links = [];

      // Add all entities to the canvas

      data.entities.forEach((entity) => {
        console.log(entity.identifierReference);

        nodes.push({
          id: `entity-${entity.identifierReference}`,
          name: `${entity.identifierType}: ${entity.identifierReference}`,
        });
      });
      // Add all conversations to the canvas
      const conversations = [
        ...new Set(data.messages.map((m) => m.object.conversationId)),
      ];
      conversations.forEach((conversation) => {
        nodes.push({
          id: `conversation-${conversation}`,
          name: conversation,
        });
      });
      // Add all messages to the canvas
      console.log(data.messages, " << Messages");
      data.messages.forEach((message) => {
        nodes.push({
          id: `message-${message.object.messageId}`,
          name: `MID: ${message.object.messageId}, Subject: ${message.object.subject}`,
        });

        // Link every message to its conversation
        links.push({
          source: `conversation-${message.object.conversationId}`,
          target: `message-${message.object.messageId}`,
        });
      });

      // Add all updates to the canvas
      data.updates.forEach((update) => {
        if (!update.object.entity) {
          return;
        }
        console.log(update);
        nodes.push({
          id: `update-${update.id}`,
          name: JSON.stringify(update.object),
        });
        // Link the update to the entity
        if (
          nodes.some(
            (node) =>
              node.id === `entity-${update.object.entity.identifierReference}`
          )
        ) {
          links.push({
            source: `update-${update.id}`,
            target: `entity-${update.object.entity.identifierReference}`,
          });
        }

        // Create links from the message to the update

        links.push({
          source: `message-${update.metadata.messageId}`,
          target: `update-${update.id}`,
        });
      });

      // Don't render links to nodes that don't exist
      const ids = nodes.map((n) => n.id);
      links = links.filter(
        (l) => ids.includes(l.target) && ids.includes(l.source)
      );
      const graphData = {
        nodes: nodes,
        links: links,
      };
      setGraphData(graphData);
    }
  }, [data]);

  useEffect(() => {
    createNodesAndLinks();
  }, [createNodesAndLinks]);

  const handleNodeClick = useCallback((node) => {
    const nodeIdParts = node.id.split("-");
    if (nodeIdParts[0] === "conversation") {
      window.open(`https://app.frontapp.com/open/${nodeIdParts[1]}`, "_blank");
    }
  }, []);

  if (!gd) {
    return null;
  }
  return (
    <div style={{ backgroundColor: "black" }}>
      <ForceGraph3D
        graphData={gd}
        nodeAutoColorBy={(d) => d.id.split("-")[0]}
        linkCurvature={0.25}
        onNodeClick={handleNodeClick}
      />
    </div>
  );
}
